import { Slide, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

export const successToaster = text => {
    toast.dismiss();
    toast.success(text , {
        position: "top-center",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        transition: Slide,
        theme: "light",
    });
};

export const errorToaster = text => {
    toast.dismiss();
    toast.error(text, {
        position: "top-center",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        transition: Slide,
        theme: "dark",
    });
}